(() => {
  const APP_URL = '/pages/elizna-app';
  const CLIENT_CARE_URL = '/pages/elizna™-client-care';

  const normalize = (value) =>
    (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  const updateDrawerClientCare = (scope = document) => {
    const drawer =
      scope.querySelector?.('#menu-drawer') ||
      scope.querySelector?.('.menu-drawer') ||
      document.querySelector('#menu-drawer, .menu-drawer');

    if (!drawer) return;

    drawer.querySelectorAll('a').forEach((anchor) => {
      const label = normalize(anchor.textContent);

      if (
        label === 'contact' ||
        label === 'client care' ||
        label === 'elizna™ client care' ||
        label === 'elizna client care'
      ) {
        anchor.setAttribute('href', CLIENT_CARE_URL);
      }
    });
  };

  const isExploreAppLabel = (value) => {
    const label = normalize(value);
    return (
      label === 'explore the app' ||
      label === 'explore the elizna™ app' ||
      label === 'explore the elizna app'
    );
  };

  const makeAppCtaLink = (el) => {
    if (!(el instanceof HTMLElement)) return;
    if (!isExploreAppLabel(el.textContent)) return;

    if (el.tagName.toLowerCase() === 'a') {
      el.setAttribute('href', APP_URL);
      return;
    }

    const anchor = document.createElement('a');
    anchor.href = APP_URL;
    anchor.className = el.className
      .replace('elizna-app-v5__cta--disabled', '')
      .replace('elizna-app-showcase-v3__cta--disabled', '')
      .replace(/\s+/g, ' ')
      .trim();

    anchor.innerHTML = el.innerHTML;
    el.replaceWith(anchor);
  };

  const updateAppPromoCtas = (scope = document) => {
    const selector = [
      '.elizna-app-v5__cta',
      '.elizna-app-showcase-v3__cta',
      '.elizna-app-promo__cta',
      '[class*="elizna-app"][class*="cta"]'
    ].join(',');

    scope.querySelectorAll?.(selector).forEach(makeAppCtaLink);
  };

  const scan = (scope = document) => {
    updateDrawerClientCare(scope);
    updateAppPromoCtas(scope);
  };

  const init = () => {
    scan();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          scan(node);
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });
})();
